/*
 * FIX 2026-07-29: make the "BUY NOW" buttons actually buy.
 *
 * The product page carries five big green BUY NOW buttons between roughly 4,700px
 * and 7,900px. Every one is a GemPages "scroll-to" button pointed at
 * #scroll-to-top. Proven on the live site: clicking one from 4,555px down left the
 * cart at 0 items and threw the shopper to scroll position 0.
 *
 * So from ~2,000px down a 9,669px page - about 80% of it - there was no working
 * buy control. A shopper who scrolls, reads the reviews, decides yes, and taps the
 * green button lands back at the top with an empty cart and no explanation.
 *
 * WHY THIS LIVES IN THE THEME AND NOT IN THE GEMPAGES FILES:
 * The buttons sit in sections/gp-*.liquid, which GemPages regenerates on every
 * republish. Editing those files gets silently reverted the next time someone
 * saves a page. This file is a theme asset GemPages does not own, so the fix
 * survives. The tidy long-term fix is still to repoint the buttons in the GemPages
 * editor; this holds the line until someone does.
 *
 * Deliberately conservative: it only touches buttons that BOTH read "buy now" AND
 * point at #scroll-to-top. Anything else on the page is left alone.
 */
(function () {
  'use strict';

  var SCROLL_LINK = '#scroll-to-top';

  function labelOf(el) {
    // GemPages puts the visible words in aria-label as HTML, and also in the DOM.
    return ((el.getAttribute('aria-label') || '') + ' ' + (el.textContent || ''))
      .replace(/<[^>]*>/g, ' ')
      .toLowerCase();
  }

  function realBuyButton() {
    // The one that genuinely submits, in document order, that is not disabled.
    var candidates = [
      document.getElementById('product-add-to-cart'),
      document.getElementById('product-sticky-add-to-cart'),
      document.querySelector('form[action*="/cart/add"] button[name="add"]'),
      document.querySelector('form[action*="/cart/add"] [type="submit"]')
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c && !c.disabled && c.closest('form')) return c;
    }
    return null;
  }

  function isFakeBuyNow(el) {
    if (!el) return false;
    var link = el.getAttribute('href') || '';
    var gp = el.getAttribute('gp-data') || (el.closest('gp-button') || {}).getAttribute
      ? (el.closest('gp-button') || document.createElement('div')).getAttribute('gp-data') || ''
      : '';
    var pointsAtTop = link.indexOf(SCROLL_LINK) !== -1 || gp.indexOf(SCROLL_LINK) !== -1;
    return pointsAtTop && /buy\s*now/.test(labelOf(el));
  }

  function handleClick(event) {
    var el = event.target.closest('button, a');
    if (!isFakeBuyNow(el)) return;

    var real = realBuyButton();
    if (!real) return;   // sold out or no form: leave the original behaviour alone

    // Stop GemPages' own scroll-to handler from also firing.
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    real.click();
  }

  // Capture phase, so this runs before the GemPages handler that scrolls the page.
  document.addEventListener('click', handleClick, true);

  // Strip the dead href so the button stops advertising a scroll it no longer does,
  // and so anything else reading the attribute sees the truth.
  function disarm() {
    var all = document.querySelectorAll('button[href], a[href]');
    for (var i = 0; i < all.length; i++) {
      if (isFakeBuyNow(all[i])) {
        all[i].setAttribute('data-was-scroll-to-top', 'true');
        if (all[i].tagName === 'BUTTON') all[i].removeAttribute('href');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disarm);
  } else {
    disarm();
  }
  // GemPages renders late and lazily, so sweep again once things settle.
  window.setTimeout(disarm, 2500);
  window.setTimeout(disarm, 6000);
})();
